jQuery(document).ready(function($){
	$('.add_to_cart_button').each(function(){
		$(this).append(' <span class="spinner-icon"><span class="fas fa-cog fa-spin"></span></span>');
	});

	//Load Captcha wrapper
	const checkoutPages = [
		'.wc-block-checkout__actions', //Blocks
		'.woocommerce-checkout-payment', //Classic
	];

	const checkoutButtons = [
		'button.wc-block-components-checkout-place-order-button', //Blocks
		'#place_order', //Classic
	];
	$.each(checkoutPages, function(index, sectionClass){
		if($('body.woocommerce-checkout.sc-has-checkout-turnstile ' + sectionClass).length) {
			setTimeout(function(){
				$('body.woocommerce-checkout ' + sectionClass).before('<div id="turnstile-checkout-wrapper"><input type="hidden" name="cf-turnstile-response" value=""></div>');
			}, 500);

			let checkoutButton;
			$.each(checkoutButtons, function(index, button){
				if($(button).length) checkoutButton = button;
			});

			//Wrap button to use onclick
			$(checkoutButton).after('<div id="turnstile-button-wrapper"></div>');
			$('#turnstile-button-wrapper').append($(checkoutButton));
			$('#turnstile-button-wrapper:has(' + checkoutButton + ')').on('click', function(){
				const button = $(this).find(checkoutButton);
				if(button.prop('disabled')) window.alert('Please complete the captcha before checking out');
			});

			window.renderTurnstile = function() {
				if (!window.turnstile) return;

				const siteKey = $('#turnstile-site-key').val();
				if (!siteKey) return;

				const el = document.getElementById('turnstile-checkout-wrapper');
				if (!el) return;

				if (el.dataset.rendered) return;

				$(checkoutButton).prop('disabled', true);

				turnstile.render(el, {
					sitekey: siteKey,
					callback: function(token) {
						window.turnstileToken = token;

						$('#turnstile-checkout-wrapper').find('input[name="cf-turnstile-response"]').val(token);
						console.log($('#turnstile-checkout-wrapper').find('input[name="cf-turnstile-response"]').length);

						$(checkoutButton).prop('disabled', false);

						const dispatch = wp.data.dispatch('wc/store/checkout');
						dispatch.setExtensionData('sc-turnstile', {
						    'cf-turnstile-response': window.turnstileToken
						});
					}
				});

				el.dataset.rendered = "1";
			};

			// first load
			window.renderTurnstile();

			// after Woo refresh
			$(document.body).on('updated_checkout', function() {
				$('#turnstile-checkout-wrapper').removeAttr('data-rendered');
				window.renderTurnstile();
			});
		}
	});
});